import { FieldDefinition, FormFieldDefinition, FormNode } from '@msdk/definitions'
import { KeyValue } from '@msdk/ui'
import React from 'react'

import { useFieldLabel } from '../../hooks'
import { ReadonlyFieldContainer } from './ReadonlyFieldContainer'

function isFormFieldDefinition(value: unknown): value is FormFieldDefinition {
  if (typeof value !== 'object' || value === null) {
    return false
  }

  const formDefinition = value as Partial<FormFieldDefinition>
  return (
    (formDefinition.hideDescription === null ||
      formDefinition.hideDescription === undefined ||
      typeof formDefinition.hideDescription === 'boolean') &&
    (formDefinition.overrideIDML === null ||
      formDefinition.overrideIDML === undefined ||
      typeof formDefinition.overrideIDML === 'string') &&
    (formDefinition.overrideDescription === null ||
      formDefinition.overrideDescription === undefined ||
      typeof formDefinition.overrideDescription === 'string')
  )
}

function ReadonlyFieldContent({
  value,
  fieldDef,
  formDef,
  loading,
  um,
  labelOverride,
  useLabelOverride,
  divider,
  inList: inList,
}: {
  value?: string
  fieldDef: FieldDefinition
  formDef: FormFieldDefinition
  loading?: boolean
  um?: string
  labelOverride?: string
  useLabelOverride?: boolean
  divider?: boolean
  inList?: boolean
}) {
  const fieldLabel = useFieldLabel(fieldDef, formDef)
  const showLabel = !formDef.hideDescription
  const label = !inList && showLabel ? (useLabelOverride ? labelOverride : fieldLabel) : undefined

  return (
    <ReadonlyFieldContainer>
      <KeyValue label={label} direction="column" divider={divider} loading={loading} unit={um}>
        {value}
      </KeyValue>
    </ReadonlyFieldContainer>
  )
}

export function ReadonlyField({
  node,
  loading,
  um,
  labelOverride,
  useLabelOverride,
  valueOverride,
  useValueOverride = false,
  divider = true,
  inList,
}: {
  node: FormNode
  loading?: boolean
  um?: string
  labelOverride?: string
  useLabelOverride?: boolean
  valueOverride?: string
  useValueOverride?: boolean
  divider?: boolean
  inList?: boolean
}) {
  const { fieldDefinition, formDefinition } = node.value
  if (!(fieldDefinition instanceof FieldDefinition) || !isFormFieldDefinition(formDefinition)) {
    return null
  }

  const value = useValueOverride ? valueOverride : node.value.data?.toStringForView() ?? ''

  return (
    <ReadonlyFieldContent
      value={value}
      fieldDef={fieldDefinition}
      formDef={formDefinition}
      loading={loading}
      um={um}
      labelOverride={labelOverride}
      useLabelOverride={useLabelOverride}
      divider={divider}
      inList={inList}
    />
  )
}
